import { render, staticRenderFns } from "./BuyOrdersPopUp.vue?vue&type=template&id=825a5d78"
import script from "./BuyOrdersPopUp.vue?vue&type=script&lang=js"
export * from "./BuyOrdersPopUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports